import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { ApplicationContext } from "../../../components/ApplicationProvider";
import { Banner, ConfigureButton } from "./SharedBannerStyle";
import { PATHS } from "../../../Routes";
import OfflineLicensingBannerSVG from "../../../images/offline_licensing.svg";

const OfflineLicensingBanner: React.FC = () => {
    const { t } = useContext(ApplicationContext);
    const history = useHistory();

    const handleConfigureClick = () => {
        history.push({
            pathname: PATHS.licenses,
        });
    };

    return (
        <Banner background={OfflineLicensingBannerSVG} data-testid="offline-licensing-banner">
            <div className="banner">
                <div className="text-section">
                    <h4>{t("homepage.offline_licensing_feature.offline_licensing_new")}</h4>
                    <h1>{t("homepage.offline_licensing_feature.offline_licensing_available")}</h1>
                </div>
                <ConfigureButton
                    style={{ color: "white" }}
                    onClick={handleConfigureClick}
                    data-testid="offline-licensing-button"
                >
                    {t("homepage.offline_licensing_feature.configure_offline_licensing")}
                </ConfigureButton>
            </div>
        </Banner>
    );
};

export default OfflineLicensingBanner;
